let listByClient = function (clientId) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.clientCertificates.replace('{id}', clientId), {
            headers: { 'x-access-token': hash },
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (responseJson.status === "LIST_CERTIFICATES")
                    resolve(responseJson.list);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let listOwn = function () {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.myCertificates, {
            headers: { 'x-access-token': hash },
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (responseJson.status === "LIST_CERTIFICATES")
                    resolve(responseJson.list);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

/**
 * Apre il download del PDF. Non usa fetch perché lo stream è binario:
 * uso axios-like via window.open con token in query? NO: preferisco fetch+blob
 * per portare header x-access-token.
 */
let download = function (certificateId) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        const url = global.route.certificateDownload.replace('{id}', certificateId);

        fetch(url, {
            headers: { 'x-access-token': hash },
            method: 'GET'
        })
            .then(async (response) => {
                if (!response.ok) {
                    const j = await response.json().catch(() => ({ status: "APP_ERROR" }));
                    global.checkAuth(j.status);
                    return reject(j);
                }

                const blob = await response.blob();

                // estraggo eventuale filename dal content-disposition
                let filename = 'attestato.pdf';
                const cd = response.headers.get('content-disposition');
                if (cd) {
                    const match = cd.match(/filename="?([^"]+)"?/);
                    if (match && match[1]) filename = match[1];
                }

                const objectUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objectUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(objectUrl);

                resolve();
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let regenerate = function (certificateId, payload) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.certificateRegenerate.replace('{id}', certificateId), {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(payload)
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (responseJson.status === "CERTIFICATE_REGENERATED")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

let resend = function (certificateId) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.certificateResend.replace('{id}', certificateId), {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({})
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                if (responseJson.status === "CERTIFICATE_EMAIL_SENT")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject('APP_ERROR');
            });
    });
};

const CertificateAPI = {
    listByClient,
    listOwn,
    download,
    regenerate,
    resend
};

export default CertificateAPI;
